import api from "../services/api";

const path = "acaopontoacesso";

export const getActionsPointAccess = async () => {
  return await api.get(`${path}`);
};

export const findActionPointAccess = async ({ id }) => {
  return await api.get(`${path}/${id}`);
};

export const editActionPointAccess = async ({ id, body }) => {
  return await api.put(`${path}/${id}`, body);
};

export const createActionPointAccess = async ({ body }) => {
  return await api.post(`${path}`, body);
};

export const deleteActionPointAccess = async ({ id }) => {
  return await api.delete(`${path}/${id}`);
};
